import React, { useState } from "react";
import GetRequest from "../Services/APIRequest";
import Loading from "../Components/Loading";
import Error from "../Components/Error";
import OrderDetailsModal from '../Components/OrderItemsDispatchInformation';

// 🔹 Format Date
const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

// 🔹 Date Range Helper
const getDateRange = (filter) => {
    const today = new Date();
    let start = new Date(today);
    let end = new Date(today);

    switch (filter) {
        case "Today":
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            break;
        case "This Week":
            start.setDate(today.getDate() - today.getDay());
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            break;
        case "Last Week":
            start.setDate(today.getDate() - today.getDay() - 7);
            start.setHours(0, 0, 0, 0);
            end = new Date(start);
            end.setDate(end.getDate() + 6);
            end.setHours(23, 59, 59, 999);
            break;
        case "Last 15 Days":
            start.setDate(today.getDate() - 14);
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            break;
        case "This Month":
        default:
            start = new Date();
            start.setDate(today.getDate() - 30);
            start.setHours(0, 0, 0, 0);
            end = new Date();
            end.setHours(23, 59, 59, 999);
            break;
    }

    const toDateStr = (d) => d.toISOString().split("T")[0];
    return [toDateStr(start), toDateStr(end)];
};

const OrderDispatchReportForTeam = () => {
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [dateFilter, setDateFilter] = useState("This Month");
    const [statusFilter, setStatusFilter] = useState("All");
    const [searchTerm, setSearchTerm] = useState(""); // 🔹 New

    const [startDate, endDate] = getDateRange(dateFilter);
    const { error, isLoaded, data } = GetRequest(
        `/Orders/GetOrderDispatchReportWithoutItemLevelDetails/${startDate}/${endDate}`
    );

    const orders = (data?.result || []).filter(order =>
        (statusFilter === "All" || order.orderDispatchStatus === statusFilter) &&
        (order.distributorName?.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const allStatuses = ["All", "Fully Dispatched", "Partially Dispatched", "Not Dispatched"];
    const dateOptions = ["Today", "This Week", "Last Week", "Last 15 Days", "This Month"];

    return (
        <section className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header bg-primary text-white d-flex flex-wrap justify-content-between align-items-center">
                                <h5 className="card-title mb-0">Order Dispatch Report (Summary)</h5>
                            </div>

                            <div className="card-body">
                                {/* 🔹 Filters */}
                                <div className="mb-3">
                                    <strong className="me-2">Date:</strong>
                                    {dateOptions.map(option => (
                                        <button
                                            key={option}
                                            className={`btn btn-sm me-2 mb-2 ${dateFilter === option ? "btn-primary" : "btn-outline-primary"}`}
                                            onClick={() => setDateFilter(option)}
                                        >
                                            {option}
                                        </button>
                                    ))}
                                </div>

                                <div className="mb-3">
                                    <strong className="me-2">Dispatch Status:</strong>
                                    {allStatuses.map(status => (
                                        <button
                                            key={status}
                                            className={`btn btn-sm me-2 mb-2 ${statusFilter === status ? "btn-primary" : "btn-outline-primary"}`}
                                            onClick={() => setStatusFilter(status)}
                                        >
                                            {status}
                                        </button>
                                    ))}
                                </div>

                                {/* 🔹 Search */}
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by distributor name..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>

                                {/* 🔹 Error / Loading */}
                                {error && <Error message={error.message} />}
                                {!isLoaded && <Loading />}

                                {/* 🔹 Mobile Cards */}
                                {isLoaded && !error && (
                                    <>
                                        <div className="d-block d-md-none">
                                            {orders.length === 0 ? (
                                                <div className="text-center text-muted">No orders found</div>
                                            ) : (
                                                orders.map((order, index) => (
                                                    <div key={order.orderId} className="card mb-2 shadow-sm border">
                                                        <div className="card-body p-2 d-flex flex-column">
                                                            <h6 className="mb-1"><strong>{order.orderNumber}</strong></h6>
                                                            <p className="mb-1 text-muted small">Order Date: {formatDate(order.orderPlacedDate)}</p>
                                                            <p className="mb-1 text-muted small">Distributor: {order.distributorName}</p>
                                                            <div className="d-flex align-items-center">
                                                                <span className={`badge bg-${order.orderDispatchStatus.includes("Not") ? "danger" : order.orderDispatchStatus.includes("Partially") ? "warning" : "success"}`}>
                                                                    {order.orderDispatchStatus}
                                                                </span>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-info btn-sm ms-2"
                                                                    aria-label="View Details"
                                                                    onClick={() => setSelectedOrderId(order.orderLineId)}
                                                                >
                                                                    <i className="fa fa-info-circle"></i> {/* Info icon */}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>


                                        {/* 🔹 Table View */}
                                        <div className="table-responsive d-none d-md-block">
                                            <table className="table table-bordered table-striped table-hover">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Order Number</th>
                                                        <th>Order Date</th>
                                                        <th>Distributor</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {orders.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="5" className="text-center text-muted">No orders found</td>
                                                        </tr>
                                                    ) : (
                                                        orders.map((order, index) => (
                                                            <tr key={order.orderId}>
                                                                <td>{index + 1}</td>
                                                                <td>
                                                                    <button
                                                                        className="btn btn-link p-0"
                                                                        onClick={() => setSelectedOrderId(order.orderLineId)}
                                                                    >
                                                                        {order.orderNumber}
                                                                    </button>
                                                                </td>
                                                                <td>{formatDate(order.orderPlacedDate)}</td>
                                                                <td>{order.distributorName}</td>
                                                                <td>{order.orderDispatchStatus}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selectedOrderId && (
                <OrderDetailsModal
                    orderId={selectedOrderId}
                    onClose={() => setSelectedOrderId(null)}
                />
            )}
        </section>
    );
};

export default OrderDispatchReportForTeam;
